import {Component, inject, OnInit} from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { Store } from "@ngrx/store";
import { appStarted } from "./state/auth/auth.actions";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import {SwUpdate} from "@angular/service-worker";

@Component({
  selector: "binsta-root",
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
})
export class AppComponent implements OnInit {
  title = "binsta";
  private swUpdate = inject(SwUpdate);

  constructor(private store: Store) { }

  ngOnInit(): void {
    if (this.swUpdate.isEnabled) {
      // Catch the unrecoverable state (e.g., cached chunks 404ing after long offline period)
      this.swUpdate.unrecoverable.subscribe(event => {
        console.warn('Service worker unrecoverable state reached. Forcing reload.');
        window.location.reload();
      });
    }
    this.store.dispatch(appStarted());
  }
}